import React from 'react'
import { useMatch, Navigate } from 'react-router-dom'
import Modeler from '../pages/ModelerPage'

const ModelerWrapper = () => {
  const match = useMatch('/:org/:project/*')

  const rest = match?.params['*'] || ''
  const segments = rest.split('/')

  const file = segments.pop() // npr: diagram.bpmn
  const type = segments.pop() // npr: bpmn
  const modeler = segments.pop() // treba da bude 'modeler'
  const directoryPath = segments.join('/') // ostatak putanje

  if (modeler !== 'modeler') {
    return <Navigate to='/not-authorized' />
  }

  return <Modeler type={type!} file={file!} directoryPath={directoryPath} />
}

export default ModelerWrapper
